import { normalizeReviewOutcome } from "./deletionCaseOutcomes";

const asArray = (value) => (Array.isArray(value) ? value : []);

function platformLabel(platform) {
  if (platform === "jameda") return "Jameda";
  return "Google";
}

/** Build a public listing URL when the API omits platform_url. */
export function buildPlatformListingUrl(locationName, platform = "google") {
  const name = (locationName || "").trim();
  if (!name) return "";
  const query = encodeURIComponent(name);
  if (platform === "jameda") {
    return `https://www.jameda.de/suche?q=${query}`;
  }
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
}

/** Prefer API URL; fall back to a Maps/Jameda search for the location name. */
export function resolveReviewPlatformUrl(item) {
  if (!item) return "";
  const fromApi = (item.platformUrl || item.platform_url || "").trim();
  if (fromApi) return fromApi;
  const name = item.locationName || item.location_name || "";
  const platform = item.platform || "google";
  return buildPlatformListingUrl(name, platform);
}

export { platformLabel };

/** Normalize a case review item from client or admin API payloads. */
export function normalizeDeletionCaseReviewItem(raw) {
  if (!raw) return null;
  const isAnonymous = Boolean(raw.is_anonymous ?? raw.isAnonymous);
  const authorRaw = raw.author || "";
  const locationName = raw.location_name || raw.locationName || "";
  const platform = raw.platform || "google";
  const platformUrl =
    (raw.platform_url || raw.platformUrl || "").trim() ||
    buildPlatformListingUrl(locationName, platform);
  return {
    id: raw.id,
    reviewId: raw.review_id ?? raw.reviewId ?? raw.review,
    rating: Number(raw.rating) || 0,
    author: isAnonymous ? "Anonym" : authorRaw || "—",
    isAnonymous,
    text: raw.text || raw.review_text || "",
    locationName,
    platform,
    platformUrl,
    createTime: raw.create_time || raw.createTime || null,
    authorPhoto: raw.author_photo || raw.authorPhoto || null,
    deletionOutcome: normalizeReviewOutcome(raw.deletion_outcome || raw.deletionOutcome),
  };
}

export function normalizeDeletionCaseReviewItems(items) {
  return asArray(items)
    .map(normalizeDeletionCaseReviewItem)
    .filter(Boolean);
}

export function formatReviewDateDe(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

/** Relative time for admin review cards (e.g. "2 days ago"). */
export function formatRelativeReviewTime(iso, t) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";

  const diffMs = Date.now() - d.getTime();
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (days < 1) return t?.("adminTable.today") || "Today";
  if (days === 1) return t?.("adminTable.yesterday") || "Yesterday";
  if (days < 14) {
    return t?.("adminTable.daysAgo", { count: days }) || `${days} days ago`;
  }
  return formatReviewDateDe(iso);
}
